import React from 'react';
    import SafeIcon from './common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const NetworkStatsCard = ({ hashrate, difficulty }) => {
      const formatNumber = (num) => {
        if (!num || num === 0 || isNaN(num)) return '-';
        
        console.log('Formatting number:', num, 'type:', typeof num, 'isNaN:', isNaN(num));
        
        // Handle very large numbers properly
        if (num >= 1000000000000000) {
          return `${(num / 1000000000000000).toFixed(2)} PH/s`;
        }
        if (num >= 1000000000000) {
          return `${(num / 1000000000000).toFixed(2)} TH/s`;
        }
        if (num >= 1000000000) {
          return `${(num / 1000000000).toFixed(2)} GH/s`;
        }
        if (num >= 1000000) {
          return `${(num / 1000000).toFixed(2)} MH/s`;
        }
        return num?.toString() || '-';
      };

      const formatDifficulty = (num) => {
        if (!num || num === 0 || isNaN(num)) return '-';
        
        console.log('Formatting difficulty:', num, 'type:', typeof num, 'isNaN:', isNaN(num));
        
        // Format difficulty with appropriate units
        if (num >= 10000000000000) {
          return `${(num / 10000000000000).toFixed(2)} T`;
        }
        if (num >= 1000000000) {
          return `${(num / 1000000000).toFixed(2)} B`;
        }
        if (num >= 1000000) {
          return `${(num / 1000000).toFixed(2)} M`;
        }
        return num?.toString() || '-';
      };

      const TrendArrow = ({ trend }) => {
        const arrowStyle = "w-4 h-4";
        if (trend === 'up') return <FiIcons.FiTrendingUp className={`${arrowStyle} text-green-400`} />;
        if (trend === 'down') return <FiIcons.FiTrendingDown className={`${arrowStyle} text-red-400`} />;
        return <FiIcons.FiTrendingUp className={`${arrowStyle} text-orange-400 rotate-90`} />;
      };

      console.log('NetworkStatsCard received:', { hashrate, difficulty });

      return (
        <div className="bg-bitcoin-card border border-white/5 p-6 rounded-2xl backdrop-blur-sm hover:border-bitcoin/30 transition-colors duration-300">
          <div className="flex items-start justify-between mb-4">
            <span className="text-gray-400 text-sm font-medium">Netzwerk-Statistik</span>
            <div className="p-2 bg-white/5 rounded-lg text-bitcoin">
              <SafeIcon icon={FiIcons.FiActivity} className="w-5 h-5" />
            </div>
          </div>
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <span className="text-xs text-gray-500">Hashrate</span>
                <div className="text-lg font-bold text-white font-mono">{formatNumber(hashrate?.value)}</div>
              </div>
              <TrendArrow trend={hashrate?.trend} />
            </div>
            <div className="flex justify-between items-center">
              <div>
                <span className="text-xs text-gray-500">Difficulty</span>
                <div className="text-lg font-bold text-white font-mono">{formatDifficulty(difficulty?.value)}</div>
              </div>
              <TrendArrow trend={difficulty?.trend} />
            </div>
          </div>
        </div>
      );
    };

    export default NetworkStatsCard;